import * as React from 'react';
import type { NextPage } from 'next';
import { ChatRoot } from '@belong/livechat';
import { withServerSideAppProps } from 'src/helpers/config/withServerSideAppProps';

// NOTE: this is a double-override, due to the presence of global-styles.css which itself overrides body background
const SetTransparentBody = () => <style>{`html body { background: transparent !important }`}</style>;

const ChatPage: NextPage = () => (
  <>
    <SetTransparentBody />
    <ChatRoot />
  </>
);

const getServerSidePageProps = () => ({});
export const getServerSideProps = withServerSideAppProps(getServerSidePageProps, false);

export default ChatPage;
